import React, { useState, useEffect } from 'react';

const MiniModalEditarNomePeca = ({ show, onClose, styles, analisesPeca = [], pecaNum = null, patchNomePeca, setAnalisesPeca, setDefeitosGrid }) => {
    const [localNome, setLocalNome] = useState("");
    const [idPeca, setIdPeca] = useState(null);

    // Inicializa localNome e idPeca quando o modal abre ou quando pecaNum mudar
    useEffect(() => {
        if (show && pecaNum != null) {
            const pecaAnalise = analisesPeca.find(a => String(a.peca) === String(pecaNum));
            setLocalNome(pecaAnalise?.pecaCustomizada || "");
            setIdPeca(pecaAnalise?.idMpTriangulacaoRevAnalisePeca || null);
        } else if (show) {
            setLocalNome("");
            setIdPeca(null);
        }
    }, [show, pecaNum, analisesPeca]);

    if (!show) return null;

    const handleSave = async () => {
        const novoNome = localNome;
        if (idPeca && novoNome) {
            if (typeof patchNomePeca === 'function') {
                await patchNomePeca({ idMpTriangulacaoRevAnalisePeca: idPeca, pecaCustomizada: novoNome });
            }
            if (typeof setAnalisesPeca === 'function') {
                setAnalisesPeca(prev => prev.map(a =>
                    a.idMpTriangulacaoRevAnalisePeca === idPeca
                        ? { ...a, pecaCustomizada: novoNome }
                        : a
                ));
            }
            if (typeof setDefeitosGrid === 'function') {
                setDefeitosGrid(prev => prev.map(d =>
                    d.idMpTriangulacaoRevAnalisePeca === idPeca
                        ? { ...d, pecaCustomizada: novoNome }
                        : d
                ));
            }
            onClose && onClose();
        }
    };

    return (
        <div className={styles?.modalOverlay} style={{ zIndex: 9999 }}>
            <div style={{
                background: '#e8f0f9',
                borderRadius: 12,
                boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
                padding: '32px 32px 28px 32px',
                minWidth: 340,
                maxWidth: 400,
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                top: '1vh'
            }}>
                <div style={{ fontWeight: 700, fontSize: '1.2rem', marginBottom: 18, textAlign: 'center' }}>
                    Editar nome da peça
                </div>
                <div style={{ margin: '18px 0 10px 0', fontWeight: 500, fontSize: '1.05rem', textAlign: 'center' }}>
                    Digite o novo nome:
                    {localNome && (
                        <span style={{ marginLeft: 10, color: '#175699', fontWeight: 600, fontSize: '0.98rem' }}>
                            (nome atual: {localNome})
                        </span>
                    )}
                </div>
                <input
                    type="text"
                    value={localNome}
                    onChange={e => setLocalNome(e.target.value)}
                    style={{
                        width: '100%',
                        maxWidth: 260,
                        fontSize: '1.05rem',
                        padding: '8px 12px',
                        borderRadius: 6,
                        border: '1px solid #ccc',
                        margin: '0 auto',
                        display: 'block',
                        textAlign: 'center',
                        fontWeight: 500
                    }}
                />
                <div style={{ display: 'flex', gap: 16, marginTop: 24, justifyContent: 'center' }}>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ padding: '6px 18px', fontWeight: 600, fontSize: '1rem', background: '#ffffffff', color: '#222', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                    >Cancelar</button>
                    <button
                        type="button"
                        onClick={handleSave}
                        style={{ padding: '6px 18px', fontWeight: 600, fontSize: '1rem', background: '#202D3B', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}
                    >Salvar</button>
                </div>
            </div>
        </div>
    );
};

export default MiniModalEditarNomePeca;
